import React from "react";
import PropTypes from "prop-types";

function Checkbox({ isOverride, handleOnChecked, name }) {
  
  return (
    <div className="create-module__formControl create-module__formControl--checkbox">
      <div className="create-module__formControl--title-checkbox">
        Delete all existing modules before creating new
      </div>
      <label
        htmlFor="create-module__input--checkbox"
        className="create-module__label--checkbox"
      >
        <input
          id="create-module__input--checkbox"
          name={name}
          onChange={handleOnChecked}
          className="create-module__input--checkbox"
          type="checkbox"
          checked={isOverride}
        />
        <span className="create-module__slider--checkbox create-module__round--checkbox" />
      </label>
    </div>
  );
}

Checkbox.defaultProps = {};

Checkbox.propTypes = {
  isOverride: PropTypes.bool.isRequired,
  handleOnChecked: PropTypes.func.isRequired,
};

export default Checkbox;
